<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-user-chart"></i> Comissões <small>Listagem de Comissões</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-user-chart"></i> Comissões</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title"> Listagem de Comissões</h3>

                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <router-link style="display: none" class="btn btn-app" :to="{ name: 'form-comissao', params: { id: 0 }}">
                                <i class="fas fa-upload"></i> Cadastrar Comissão
                            </router-link>
                            <button class="btn btn-app" data-toggle="modal" data-target="#modal-default">
                                <i class="fas fa-upload"></i> Importar Comissões
                            </button>
                        </div>
                        <client-table :options="options" ref="dataTable">
                            <thead class="table-secondary">
                                <tr>
                                    <th>EMPREENDIMENTO</th>
                                    <th>STATUS</th>
                                    <th>CHAVE</th>
                                    <th>CLIENTE</th>
                                    <th>EMPREEND</th>
                                    <th>PROCESSO</th>
                                    <th>ESTÁGIO DE CONTRATO</th>
                                    <th>DATA CONTRATO UAU</th>
                                    <th>FINALID. UAU</th>
                                    <th>PLANO INDEX</th>
                                    <th>MANUTENÇÃO</th>
                                    <th>CAT. USO</th>
                                    <th>TIPOLOGIA</th>
                                    <th>M²</th>
                                    <th>RECIBO</th>
                                    <th>TERMO FIADOR</th>
                                    <th>CONTRATO DE FIADOR</th>
                                    <th>DATA SICAQ OK</th>
                                    <th>DATA INÍCIO SICAQ</th>
                                    <th>VALIDADE SICAQ</th>
                                    <th>VLR TABELA</th>
                                    <th>APONTAMENTOS</th>
                                    <th>AGREGACAO</th>
                                    <th>APROVAÇÃO</th>
                                    <th>ALÇADA</th>
                                    <th>MOTIVO FORA ALÇADA</th>
                                    <th>CLAUSULA EM TEMPO</th>
                                    <th>EQUIPE</th>
                                    <th>OBS. PARA PRÊMIO</th>
                                    <th>VENDEDOR(A) / PARCEIRO(A)</th>
                                    <th>GERENTE</th>
                                    <th>GESTOR</th>
                                    <th>ENTRADA</th>
                                    <th>VLR VENDA</th>
                                    <th>VLR VENDA UAU</th>
                                    <th>GARANTIDO</th>
                                    <th>GARANTIDO UAU</th>
                                    <th>PRÉ-CHAVES</th>
                                    <th>PRÉ-CHAVES UAU</th>
                                    <th>PRÓ SOLUTO PÓS-CHAVES</th>
                                    <th>PÓS-CHAVES UAU</th>
                                    <th>PRÓ-SOLUTO TOTAL</th>
                                    <th>TIPO VENDA - FLUXO</th>
                                    <th>FINANC. CEF</th>
                                    <th>FINANC. CEF UAU</th>
                                    <th>DATA ENTREGA</th>
                                    <th>VALOR M²</th>
                                    <th>VALOR M² PRÉ-CHAVES</th>
                                    <th>PRÓ-SOLUTO PRÉ-CHAVES</th>
                                    <th>TIPOVENDA-CEF-DIRETO-VISTA</th>
                                    <th>CEF?</th>
                                    <th>FLUXO</th>
                                    <th>NOME COMPLETO CORRETOR VENDA</th>
                                    <th>EMPREENDIMENTO</th>
                                    <th>BLOCO</th>
                                    <th>UNIDADE</th>
                                    <th>RL</th>
                                    <th>M² GARANTIDO</th>
                                    <th>CPF CLIENTE</th>
                                    <th>NAPOLIAO COMISSÃO</th>
                                    <th>A2</th>
                                    <th>TIPOLOGIA COM ESPECIAL</th>
                                    <th>mkt - TIPOLOGIA</th>
                                    <th>COD.PRT</th>
                                    <th>SEMANA VENDA</th>
                                    <th>CHAVE EOV (EMPRESA/OBRA/VENDA)</th>
                                    <th>EMPRESA PARCEIRA</th>
                                    <th>CNPJ/CPF</th>
                                    <th>CONTA BANCARIA</th>
                                    <th>% PARCERIA</th>
                                    <th>PARCERIA VGV FUTURO</th>
                                    <th>PARCERIA VGV PAGAR MÊS</th>
                                    <th>PARCERIA PG NA CABEÇA</th>
                                    <th>C. CRÉD</th>
                                    <th>DATA DA VENDA (CANCELADA)</th>
                                    <th>DATA DO CANCELAMENTO</th>
                                    <th>EMPREENDIMENTO E UNIDADE CANCELADA</th>
                                    <th>COMISSÃO PAGA</th>
                                    <th>FOI DISTRATADO / DESCONTADO</th>
                                    <th class="min-tablet" style="width: 70px;">Ações</th>
                                </tr>
                            </thead>
                        </client-table>
                    </div>
                    <div class="card-footer">
                    </div>
                    <div class="overlay">
                        <a class="btn btn-app bg-secondary">
                            <i class="fas fa-spinner fa-pulse"></i> carregando...
                        </a>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
        <div class="modal fade" id="modal-default">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fas fa-upload"></i> Importar Comissões</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="text-muted">A planilha deve ser no formato .xlsx seguindo os padrões propostos no arquivo: <b>"COMISSAO_JUNHO_24_VENDAS - SEMANA 1.xlsx"</b>.</p>
                        <upload-editor accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" v-model="entity.file" />
                        <div class="progress">
                            <div class="progress-bar bg-primary progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" :style="'width: ' + loading + '%'">
                                <span class="sr-only">40% Complete (success)</span>
                            </div>
                        </div>
                        
                        <br />

                        <div class="card collapsed-card card-outline card-danger" v-if="logs.erro.length > 0">
                            <div class="card-header">
                                <h3 class="card-title">Logs</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body p-0 overflow-auto" style="display: none; max-height:250px">
                                <ul class="nav nav-pills flex-column">
                                    <li class="nav-item text-xs"  v-for="(item, index) in logs.erro" :key="index">
                                        <a class="nav-link" href="#"><i class="fas fa-exclamation-triangle text-danger"></i> {{item.error}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default btn-social" data-dismiss="modal"><i class="fas fa-window-close"></i> Fechar</button>
                        <button type="button" class="btn btn-primary btn-social" v-on:click="submitFile"><i class="fas fa-upload"></i> Enviar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComissaoController from "@/controllers/comissao.controller";
import format from 'date-fns/format';

export default {
    data: function () {
        return {
            entity: {},
            loading: 0,
            logs: {
                sucesso: [],
                erro: []
            },
            options: {
                "title": "Comissões",
                searchBuilder: {
                    url: "/api/comissao/datatable",
                    columns: [0, 3, 7, 27, 29, 30, 31, 32, 33],
                    liveSearch: false,
                    preDefined: {
                        criteria: [
                            {
                                condition: 'between',
                                data: 'DATA CONTRATO UAU',
                                origData: 'data_contrato_uau',
                                type: 'moment-DD/MM/YYYY',
                                value: []
                            }
                        ],
                        logic: 'AND'
                    }
                },
                columnDefs: [
                    {
                        searchBuilderType: "moment-DD/MM/YYYY",
                        targets: [7]
                    },
                    {
                        searchBuilderType: 'num',
                        targets: [32, 33]
                    },
                    {
                        searchBuilderType: 'string',
                        targets: [0]
                    }
                ],
                responsive: {
                    details: {
                        display: $.fn.dataTable.Responsive.display.childRow,
                        renderer: $.fn.dataTable.Responsive.renderer.tableAll({
                            tableClass: 'table'
                        })
                    }
                },
                "columns": [
                    { data: 'empreendimento', visible: true }, 
                    { data: 'status', visible: false }, 
                    { data: 'chave', visible: false }, 
                    { data: 'cliente', visible: true  }, 
                    { data: 'empreend', visible: false }, 
                    { data: 'processo', visible: false }, 
                    { data: 'estagio_contrato', visible: false }, 
                    {
                        data: 'data_contrato_uau',
                        visible: true,
                        "mRender": function (data) {
                            return data ? format(new Date(data),'dd/MM/yyyy') : null;
                        }
                    }, 
                    { data: 'finalidade_uau', visible: false }, 
                    { data: 'plano_index', visible: false }, 
                    { data: 'manutencao', visible: false }, 
                    { data: 'cat_uso', visible: false }, 
                    { data: 'tipologia', visible: true }, 
                    { data: 'm2', visible: false }, 
                    { data: 'recibo', visible: false }, 
                    { data: 'termo_fiador', visible: false }, 
                    { data: 'contrato_fiador', visible: false }, 
                    {
                        data: 'data_sicaq_ok',
                        visible: false,
                        "mRender": function (data) {
                            return data ? format(new Date(data),'dd/MM/yyyy') : null;
                        }
                    }, 
                    {
                        data: 'data_inicio_sicaq',
                        visible: false,
                        "mRender": function (data) {
                            return data ? format(new Date(data),'dd/MM/yyyy') : null;
                        }
                    }, 
                    {
                        data: 'validade_sicaq',
                        visible: false,
                        "mRender": function (data) {
                            return data ? format(new Date(data),'dd/MM/yyyy') : null;
                        }
                    }, 
                    { data: 'vlr_tabela', visible: true }, 
                    { data: 'apontamentos', visible: false }, 
                    { data: 'agregacao', visible: false }, 
                    { data: 'aprovacao', visible: false }, 
                    { data: 'alcada', visible: false }, 
                    { data: 'motivo_fora_alcada', visible: false }, 
                    { data: 'clausula_tempo', visible: false }, 
                    { data: 'equipe', visible: true }, 
                    { data: 'obs_premio', visible: false }, 
                    { data: 'vendedor_parceiro', visible: true }, 
                    { data: 'gerente', visible: true }, 
                    { data: 'gestor', visible: true }, 
                    { data: 'valor_entrada', visible: true  }, 
                    { data: 'valor_venda', visible: true  }, 
                    { data: 'valor_venda_uau', visible: false }, 
                    { data: 'valor_garantido', visible: false }, 
                    { data: 'valor_garantido_uau', visible: false }, 
                    { data: 'valor_pre_chaves', visible: false }, 
                    { data: 'valor_pre_chaves_uau', visible: false }, 
                    { data: 'valor_pro_soluto_pos_chaves', visible: false }, 
                    { data: 'valor_pos_chaves_uau', visible: false }, 
                    { data: 'valor_pro_soluto_total', visible: false }, 
                    { data: 'tipo_venda_fluxo', visible: false }, 
                    { data: 'valor_financ_cef', visible: false }, 
                    { data: 'valor_financ_cef_uau', visible: false }, 
                    {
                        data: 'data_entrega',
                        visible: false,
                        "mRender": function (data) {
                            return data ? format(new Date(data),'dd/MM/yyyy') : null;
                        }
                    }, 
                    { data: 'valor_m2', visible: false }, 
                    { data: 'valor_m2_pre_chaves', visible: false }, 
                    { data: 'pro_soluto_pre_chaves', visible: false }, 
                    { data: 'tipo_venda_cef_direto_vista', visible: false }, 
                    { data: 'cef', visible: false }, 
                    { data: 'fluxo', visible: false }, 
                    { data: 'nome_completo_corretor_venda', visible: false }, 
                    { data: 'empreendimento2', visible: false }, 
                    { data: 'bloco', visible: false }, 
                    { data: 'unidade', visible: false }, 
                    { data: 'rl', visible: false }, 
                    { data: 'm2_garantido', visible: false }, 
                    { data: 'cpf_cliente', visible: false }, 
                    { data: 'napoliao_comissao', visible: false }, 
                    { data: 'a2', visible: false }, 
                    { data: 'tipologia_especial', visible: false }, 
                    { data: 'mkt_tipologia', visible: false }, 
                    { data: 'cod_prt', visible: false }, 
                    { data: 'semana_venda', visible: false }, 
                    { data: 'chave_eov_empresa', visible: false }, 
                    { data: 'empresa_parceira', visible: false }, 
                    { data: 'cnpj_cpf', visible: false }, 
                    { data: 'conta_bancaria', visible: false }, 
                    { data: 'porcentagem_parceria', visible: false }, 
                    { data: 'parceria_vgv_futuro', visible: false }, 
                    { data: 'parceria_vgv_pagar_mes', visible: false }, 
                    { data: 'parceria_pg_na_cabeca', visible: false }, 
                    { data: 'c_cred', visible: false }, 
                    {
                        data: 'data_venda_cancelada',
                        visible: false,
                        "mRender": function (data) {
                            return data ? format(new Date(data),'dd/MM/yyyy') : null;
                        }
                    }, 
                    {
                        data: 'data_cancelamento',
                        visible: false,
                        "mRender": function (data) {
                            return data ? format(new Date(data),'dd/MM/yyyy') : null;
                        }
                    }, 
                    { data: 'empreendimento_unidade_cancelada', visible: false }, 
                    { data: 'comissao_paga', visible: false }, 
                    { data: 'foi_distratado_descontado', visible: false },
                    {
                    "bSortable": false,
                        data: null,
                            "sClass": "text-center py-0",
                                "mRender": function (data, type, full) {
                                    return `<div class="btn-group">
                                        <button onclick="$(this).trigger('view', ${full.id_comissao})" rel="tooltip" title="Ver Comissões" class="btn bg-gradient-primary btn-sm"><i class="fas fa-user-chart"></i></button>
                                        <button onclick="$(this).trigger('edit', ${full.id_comissao})" rel="tooltip" title="Editar" class="btn bg-gradient-primary btn-sm"><i class="fas fa-pencil-alt"></i></button>
                                    </div>`;
                                }
                    }
                ]
            }
        };
    },
    methods:{
        submitFile: function(event) {        
            event.target.disabled = true;
            const vm = this;
            
            const formData = new FormData();
            formData.append("file", this.entity.file);

            vm.loading = 30;

            ComissaoController.upload(formData)
            .then(response => {

                vm.loading = 100;
                vm.logs.erro = response.data.result;

                if(!response.data.success)
                {
                    this.$toastr.error(response.data.error, 'Erro!', {
                        timeOut: 8000,
                        onHidden: function() {
                            event.target.disabled = false;
                            vm.loading = 0;
                        }
                    });
                    return;
                }

                this.$toastr.success("Dados importados com sucesso.", "Aviso",
                {
                    onHidden: function() {
                        event.target.disabled = false;
                        vm.$refs.dataTable.reload();
                        $('#modal-default').modal('hide');
                        vm.loading = 0;
                    }
                });
            })
            .catch(e => {
                event.target.disabled = false;
                vm.loading = 0;
                this.$toastr.error(e, 'Erro!', {timeOut: 8000});
            });
        },
    },
    mounted: function () {
        const vm = this;

        $("body").on("edit", function (event, id) { vm.$router.push({ name: 'form-comissao', params: { id: id } }).catch(() => { }); });
        $("body").on("view", function (event, id) { vm.$router.push({ name: 'view-comissao', params: { id: id } }).catch(() => { }); });

        $("#modal-default").on("hidden.bs.modal", function () {
            vm.loading = 0;
            vm.logs = {
                sucesso: [],
                erro: []
            }
        });
    }
};
</script>

<style >
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control::before {
    font-family: 'Font Awesome 5 Pro';
    font-weight: 900;
    content: "\f330" !important;
    color: rgba(7, 119, 14, 0.5) !important
}

table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td.dtr-control::before {
    font-family: 'Font Awesome 5 Pro';
    font-weight: 900;
    content: "\f32d" !important;
    color: rgba(225, 19, 19, 0.5) !important;
}

.table.dtr-details tr td:nth-child(1){
    width: 40%;
    font-weight: 900;
}
</style>